// @tennis-matches/ui/tournament-setup/steps – Modus-Auswahl (Clubmeisterschaft: ko | groupsKo | swiss)

import React from "react";
import { Trophy, Layers, Sparkles } from "lucide-react";

const MODE_CARDS = [
  { value: "ko", Icon: Trophy, titleKey: "club.mode.ko.title", descKey: "club.mode.ko.desc", disabled: false },
  { value: "groupsKo", Icon: Layers, titleKey: "club.mode.groupsKo.title", descKey: "club.mode.groupsKo.desc", disabled: false },
  { value: "swiss", Icon: Sparkles, titleKey: "club.mode.swiss.title", descKey: "club.mode.swiss.desc", disabled: true, badgeKey: "club.mode.swiss.comingSoon" },
];

/**
 * Step: Modus-Auswahl (KO | Gruppen+KO | Schweizer).
 * Props: t, value (current mode), onChange(mode).
 */
export function ModeSelectStep({ t, value, onChange }) {
  const current = value === "ko" || value === "groupsKo" || value === "swiss" ? value : "groupsKo";

  return (
    <div className="wizardStep">
      <h3 className="wizardStep__title">{t("club.mode.step.title")}</h3>
      <p className="wizardStep__hint">{t("club.mode.step.hint")}</p>
      <div className="tm-wizard-v0__format-cards tm-wizard-card--mb">
        {MODE_CARDS.map((c) => {
          const Icon = c.Icon;
          const selected = current === c.value;
          const disabled = !!c.disabled;
          return (
            <button
              key={c.value}
              type="button"
              className={`tm-wizard-v0__format-card ${selected ? "is-selected" : ""} ${disabled ? "is-disabled" : ""}`}
              onClick={() => !disabled && onChange(c.value)}
              disabled={disabled}
              aria-pressed={selected}
              aria-label={t(c.titleKey)}
            >
              <span className="tm-wizard-v0__format-card-icon">
                <Icon aria-hidden />
              </span>
              <span className="tm-wizard-v0__format-card-label">{t(c.titleKey)}</span>
              {c.badgeKey ? <span className="tm-wizard-v0__format-card-badge muted">{t(c.badgeKey)}</span> : null}
              <span className="tm-wizard-v0__format-card-desc muted">{t(c.descKey)}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
}
